import { Component, Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


@Component({
    selector: 'app-dialog-firm',
    templateUrl: './dialog.confirm.html',
})
export class DialogConfirmComponent {

    deleteString = '';

    constructor(
        public dialogRef: MatDialogRef<DialogConfirmComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
        ) {
        this.deleteString = data.name;
    }

    confirm(){
        this.dialogRef.close(true);
    }

    cancel(){
        this.dialogRef.close(false);
    }

}


// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/modules/dialog.confirm.ts